import styled from "styled-components";
export const ToggleInput = styled.input `
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;

  &:focus + label {
    &:before {
      ${({ theme, disabledStates, focused }) => !disabledStates && focused
    ? `border: 1px solid ${theme.colors.primaryLight};`
    : ""};
      ${({ type, theme, disabledStates, focused }) => {
    if (disabledStates || !focused)
        return "";
    if (type !== "radio")
        return `outline: 1px solid ${theme.colors.primaryLight};`;
    return `outline: none; box-shadow: 0 0 0 1px ${theme.colors.primaryLight};`;
}};
    }
  }

  &&:checked + label {
    &:after {
      ${({ type, theme }) => type !== "radio" ? `background-color: ${theme.colors.grey15}` : ""};
    }

    & > span {
      display: block;
    }
  }

  &:disabled,
  &:disabled:checked {
    & + label {
      pointer-events: none;
      color: rgba(${({ theme }) => theme.colors.transparentBlack}, 0.26);

      &:after {
        background-color: transparent;
        border: 1px solid
          rgba(${({ theme }) => theme.colors.transparentBlack}, 0.2);
      }

      & > span {
        svg {
          fill: rgba(${({ theme }) => theme.colors.transparentBlack}, 0.26);
        }
        ${({ type, theme }) => type === "radio"
    ? `background-color: rgba(${theme.colors.transparentBlack}, 0.2)`
    : ""};
      }
    }
  }
`;
